import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackBlogPostView, trackPageView } from '../utils/analytics';

/**
 * Sends a GA4 page_view on every client-side route change.
 * Must render inside <Router>.
 */
const GaPageViews = () => {
  const location = useLocation();

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    trackPageView(path, document.title);

    const blogMatch = location.pathname.match(/^\/blog\/([^/]+)\/?$/);
    if (blogMatch) {
      trackBlogPostView(decodeURIComponent(blogMatch[1]));
    }
  }, [location.pathname, location.search]);

  return null;
};

export default GaPageViews;
